import axios from 'axios'
import http from '@/services/http'

let cancelGetShiftReportSrc = null

export default {
  namespaced: true,
  actions: {
    async getShiftReport({ commit }, admin_shift_id) {
      if (cancelGetShiftReportSrc) {
        cancelGetShiftReportSrc.cancel()
      }
      const CancelToken = axios.CancelToken
      const source = CancelToken.source()
      cancelGetShiftReportSrc = source
      try {
        commit('pageLoader/SET_LOADING', true, { root: true })
        const res = await http.get(`admin_shift/${admin_shift_id}/report`, {
          cancelToken: source.token
        })
        return res
      } finally {
        commit('pageLoader/SET_LOADING', false, { root: true })
      }
    },
    async createAdjustment({ commit }, { data, admin_shift_id }) {
      try {
        commit('pageLoader/SET_LOADING', true, { root: true })
        const res = await http.post(`admin_shift/${admin_shift_id}/adjustment`, data)
        return res
      } finally {
        commit('pageLoader/SET_LOADING', false, { root: true })
      }
    },
    async editAdjustment({ commit }, { data, admin_shift_id }) {
      try {
        commit('pageLoader/SET_LOADING', true, { root: true })
        const res = await http.patch(`admin_shift/${admin_shift_id}/adjustment/${data.adjustment_id}`, data)
        return res
      } finally {
        commit('pageLoader/SET_LOADING', false, { root: true })
      }
    },
    async downloadReport({ commit }, admin_shift_id) {
      try {
        commit('pageLoader/SET_LOADING', true, { root: true })
        const data = await http.get(`admin_shift/${admin_shift_id}/print_report`, {
          responseType: 'blob'
        })
        const downloadUrl = window.URL.createObjectURL(new Blob([data]))
        const link = document.createElement('a')
        link.href = downloadUrl
        link.setAttribute('download', `${admin_shift_id}.pdf`)
        document.body.appendChild(link)
        link.click()
        link.remove()
      } finally {
        commit('pageLoader/SET_LOADING', false, { root: true })
      }
    },
    async printReport({ commit }, admin_shift_id) {
      try {
        commit('pageLoader/SET_LOADING', true, { root: true })
        await http.post(`admin_shift/${admin_shift_id}/print_report`, { admin_shift_id })
      } finally {
        commit('pageLoader/SET_LOADING', false, { root: true })
      }
    },
    async closeShift({ commit }, admin_shift_id) {
      try {
        commit('pageLoader/SET_LOADING', true, { root: true })
        await http.post(`admin_shift/${admin_shift_id}/close`, { admin_shift_id })
      } finally {
        commit('pageLoader/SET_LOADING', false, { root: true })
      }
    }
  }
}
